import React from "react"
import { innerContainer, inputContainer } from "../../personal.module.css"
import { Input } from "src/components/core/atoms/input"

export const CompleteSignUpForm = ( { input, disabled } ) => {
  return (
    <>
      <div className={ innerContainer }>
        <div className={ inputContainer }>
          <p>First Name</p>
          <Input.Field
            name="firstName"
            value={ input.values.firstName }
            onChange={ ( e ) => input.setValues( { ...input.values, firstName: e.target.value } ) }
            disabled={ disabled } />
          <Input.ErrorMessage name="firstName" input={ input } />
        </div>
        <div className={ inputContainer }>
          <p>Last Name</p>
          <Input.Field
            name="secondName"
            value={ input.values.secondName }
            onChange={ ( e ) => input.setValues( { ...input.values, secondName: e.target.value } ) }
            disabled={ disabled } />
          <Input.ErrorMessage name="secondName" input={ input } />
        </div>
      </div>
      <div className={ innerContainer }>
        <div className={ inputContainer }>
          <p>Phone Number</p>
          <Input.Field
            name="phoneNumber"
            value={ input.values.phoneNumber }
            onChange={ ( e ) => input.setValues( { ...input.values, phoneNumber: e.target.value } ) }
            placeholder={ "E.g.: 020 1234 5678" } disabled={ disabled } />
          <Input.ErrorMessage name="phoneNumber" input={ input } />
        </div>
      </div>
      <div className={ innerContainer }>
        <div className={ inputContainer }>
          <p>Password</p>
          <Input.Field
            name="password"
            value={ input.values.password }
            onChange={ ( e ) => input.setValues( { ...input.values, password: e.target.value } ) }
            disabled={ disabled } type="password" />
          <Input.ErrorMessage name="password" input={ input } />
        </div>

        <div className={ inputContainer }>
          <p>Repeat Password</p>
          <Input.Field
            name="passwordValidation"
            value={ input.values.passwordValidation }
            onChange={ ( e ) => input.setValues( { ...input.values, passwordValidation: e.target.value } ) }
            disabled={ disabled } type="password" />
          <Input.ErrorMessage name="passwordValidation" input={ input } />
        </div>
      </div>
    </>
  )
}

export default CompleteSignUpForm